<template lang="pug">
#set.comAll(v-dragDiv, v-show='!actionData.isMini')
  .title.moveDragDiv
    span {{ actionData.cnName }}
    i.el-icon-minus.minibtn(title='最小化', @click='miniCom')
    i.el-icon-close(title='关闭', @click='closeAdd')
  .contentCom
    el-tabs(v-model='activeName')
      el-tab-pane(v-for='(item, index) in setNav', :label='item', :name='item', :key='index')
    el-form(ref='form', size='mini', label-width='110px', v-show="activeName == '交互'")
      el-form-item(label='重力')
        el-switch(v-model='walkOption.gravity', @change='changeGravity')
      el-form-item(label='碰撞')
        el-switch(v-model='walkOption.collide', @change='changeCollide')
      el-form-item(label='Z轴锁定')
        el-switch(v-model='walkOption.fixedZAxis', @change='changefixedZAxis')
      el-form-item(label='漫游移动速度')
        el-slider(v-model='walkOption.speed', :step='0.1', :min='0.1', :max='1', show-input, @change='changeSpeed')
      el-form-item(label='鼠标缩放速度')
        el-slider(v-model='walkOption.zoomSpeed', :step='0.05', :min='0.1', :max='0.5', show-input, @change='changeZoomSpeed')
      el-form-item(label='绕模型旋转速度')
        el-slider(v-model='walkOption.focusModelRotateSpeed', :step='0.001', :min='0', :max='1', show-input, @change='changeFocusModelRotateSpeed')
      el-form-item(label='绕模型旋转')
        el-switch(v-model='walkOption.focusModel', @change='changeFocusModel')
      el-form-item(label='鼠标悬停效果')
        el-switch(v-model='walkOption.hoverEnable', @change='changeHoverEnable')
      el-form-item(label='选择呼吸效果')
        el-switch(v-model='walkOption.selectionFlash', @change='changeSelectionFlash')

    el-form(ref='form', size='mini', label-width='120px', v-show="activeName === '效果'")
      el-form-item(label='边线(GPU)')
        el-switch(v-model='contour.fouLine', @change='changeFouLine')
        span 显卡实时生成的边线
      el-form-item(label='抗锯齿(FXAA)')
        el-switch(v-model='contour.fxaa', @change='changeFxaa')
      el-form-item(label='环境光遮罩')
        el-switch(v-model='contour.ssao', @change='changeSsao')
        span (SSAO)
      //- el-form-item(label='屏幕空间反射')
      el-form-item(label='阴影')
        el-switch(v-model='contour.shadow', @change='changeShadow')
      el-form-item(label='曝光自适应')
        el-switch(v-model='contour.automaticExposure', @change='changeAutomaticExposure')

    el-form(ref='form', size='mini', label-width='90px', v-show="activeName == '环境'")
      el-form-item.alignment(label='背景')
        el-radio-group(v-model='environment.mode', @change='changeBgc')
          el-radio(v-for='(item, index) in bgcModels', :key='index', :label='item.value')
            .skybox-list
              img.skybox-image(:src="bgcImg(item)" v-if="bgcImg(item)")
              .skybox-image(v-else)
              .name {{item.label}}
      el-form-item(label='天气')
        el-radio-group(v-model='environment.weather', @change='changeWeather')
          el-radio(v-for='(item, index) in weatherType', :key='index', :label='item.value') {{item.showName}}
      el-form-item(:label='weatherName' v-if="showWeatherName")
        el-radio-group(v-model='environment.weatherIntensity', @change='changeWeatherIntensity')
          el-radio(v-for='(item, index) in weatherIntensityList', :key='index', :label='item.value') {{item.showName}}
        //- el-checkbox(v-model='checkSpace', @change='skyBox') 天空盒
        //- .choice 选择背景色
        //- el-color-picker(popper-class='popperClass', size='mini', color-format='hex', v-model='backgroundColor', @change='bgcSet')
      //- el-form-item(label='亮度')
      //-   el-slider(v-model='effectOption3D.intensity', :step='1', :min='0', :max='100', @change='changeIntensity', show-input)
      //- el-form-item(label='饱和度')
      //-   el-slider(v-model='effectOption3D.saturation', :step='1', :min='0', :max='100', @change='changeSaturation', show-input)
      //- el-form-item(label='时间', v-if='checkSpace')
      //-   el-slider(v-model='effectOption3D.time', :step='1', :min='6', :max='18', @change='changeTime', show-input)
      //- el-form-item(label='色温')
      //-   el-radio-group(v-model='effectOption3D.temperature', @change='changeTemperature')
      //-     el-radio(v-for='(item, index) in curTemperatureList', :key='index', :label='item.value') {{ item.name }}
    el-form(ref='form', size='mini', label-width='90px', v-show="activeName == '色彩'")
      el-form-item(label='亮度')
        el-slider(v-model='effectOption3D.intensity', :step='1', :min='0', :max='100', @change='changeIntensity', show-input)
      el-form-item(label='饱和度')
        el-slider(v-model='effectOption3D.saturation', :step='1', :min='0', :max='100', @change='changeSaturation', show-input)
      el-form-item(label='色温')
        el-radio-group(v-model='effectOption3D.temperature', @change='changeTemperature')
          el-radio(v-for='(item, index) in curTemperatureList', :key='index', :label='item.value') {{ item.name }}
</template>

<script>
import mongeApiMlib from '@/CommonDP/mongeView/mongeApiMlib';
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      setNav: ['交互', '效果', '环境', '色彩'],
      activeName: '交互',
      backgroundColor: '#FFFFFF',
      checkSpace: false,
      walkOption: {}, // 交互配置项
      contour: {}, // 效果
      environment: {}, // 环境
      selector: {}, // 选择
      effectOption3D: {} // 色彩
    };
  },
  computed: {
    curTemperatureList() {
      return mongeApiMlib.curTemperatureList();
    },
    bgcModels() {
      return mongeApiMlib.getBgcList();
    },
    weatherType() {
      return mongeApiMlib.weatherType();
    },
    weatherIntensityList() {
      return mongeApiMlib.weatherIntensityList();
    },
    showWeatherName() {
      return this.environment.weather === 2 || this.environment.weather === 3;
    },
    weatherName() {
      if (this.environment.weather === 2) {
        return "降雪量";
      } else if (this.environment.weather === 3) {
        return "降雨量";
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // const { x, y, z } = mongeApiMlib.get3DBgc();
      // if (x === -1 && y === -1 && z === -1) {
      //   this.checkSpace = true;
      //   this.backgroundColor = '#FFFFFF';
      // } else {
      //   this.checkSpace = false;
      //   this.backgroundColor = this.colorRGBtoHex(x, y, z);
      // }
      // 交互
      this.walkOption = { ...mongeApiMlib.walkOption3D() };
      // 效果
      this.contour = { ...mongeApiMlib.contour() };
      // 环境
      this.environment = { ...mongeApiMlib.environment() };
      // this.selector = { ...mongeApiMlib.selector() };
      // 色彩
      this.effectOption3D = { ...mongeApiMlib.effectOption3D() };
    },
    colorRGBtoHex(r, g, b) {
      var hex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      return hex;
    },
    bgcImg(item) {
      const imageDescribe = {
        "默认": () => require("@/CommonDP/mongeView/modelProMax/images/default.png"),
        "阴天": () => require("@/CommonDP/mongeView/modelProMax/images/cloudy.png"),
        "黄昏": () => require("@/CommonDP/mongeView/modelProMax/images/dusk.png"),
        "夜晚": () => require("@/CommonDP/mongeView/modelProMax/images/night.png")
      };
      return imageDescribe[item.label]?.();
    },
    changeBgc(val) {
      mongeApiMlib.changeBgc(val);
    },
    async changeWeather(val) {
      mongeApiMlib.changeWeather(val);
      // await this.$nextTick();
      // this.environment.weatherIntensity = mongeApiMlib.getweatherIntensity();
      // mongeApiMlib.changeWeatherIntensity(val);
    },
    changeWeatherIntensity(val) {
      mongeApiMlib.changeWeatherIntensity(val);
    },
    miniCom() {
      this.$emit('closeCom', 'set', true);
    },
    closeAdd() {
      this.$emit('closeCom', 'set', false);
    },
    bgcSet(val) {
      this.checkSpace = false;
      const array = this.olorRgb(val);
      mongeApiMlib.set3DBgc(array);
    },
    skyBox(val) {
      if (val) {
        mongeApiMlib.setSkyBox();
        this.backgroundColor = '#FFFFFF';
      } else {
        this.bgcSet(this.backgroundColor);
      }
    },
    // 速度修改
    changeSpeed(val) {
      mongeApiMlib.changeSpeed(val);
    },
    // 旋转速度修改
    changeRotateSpeed(val) {
      mongeApiMlib.changeRotateSpeed(val);
    },
    // 固定Z轴
    changefixedZAxis(val) {
      mongeApiMlib.changefixedZAxis(val);
    },
    // 绕模型旋转速度
    changeFocusModelRotateSpeed(val) {
      mongeApiMlib.changeFocusModelRotateSpeed(val);
    },
    // 鼠标缩放速度
    changeZoomSpeed(val) {
      mongeApiMlib.changeZoomSpeed(val);
    },
    // 绕模型旋转
    changeFocusModel(val) {
      mongeApiMlib.changeFocusModel(val);
    },
    // 鼠标悬停效果
    changeHoverEnable(val) {
      mongeApiMlib.changeHoverEnable(val);
    },
    // 选择呼吸效果
    changeSelectionFlash(val) {
      mongeApiMlib.changeSelectionFlash(val);
    },
    // 碰撞检测
    changeCollide(val) {
      mongeApiMlib.changeCollide(val);
    },
    // 重力
    changeGravity(val) {
      mongeApiMlib.changeGravity(val);
    },
    // 模型边线GPU
    changeFouLine(val) {
      mongeApiMlib.changeFouLine(val);
    },
    // 抗锯齿FXAA
    changeFxaa(val) {
      mongeApiMlib.changeFxaa(val);
    },
    // 环境光遮蔽
    changeSsao(val) {
      mongeApiMlib.changeSsao(val);
    },
    // 阴影
    changeShadow(val) {
      mongeApiMlib.changeShadow(val);
    },
    // 曝光自适应
    changeAutomaticExposure(val) {
      mongeApiMlib.changeAutomaticExposure(val);
    },
    // 亮度
    changeIntensity(val) {
      mongeApiMlib.changeIntensity(val);
    },
    // 饱和度
    changeSaturation(val) {
      mongeApiMlib.changeSaturation(val);
    },
    // 色温
    changeTemperature(val) {
      mongeApiMlib.changeTemperature(val);
    },
    // 天空盒时间
    changeTime(val) {
      mongeApiMlib.changeTime(val);
    },
    // hex转rgb数组
    olorRgb(color) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = color.toLowerCase();
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = '#';
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        // 处理六位的颜色值
        var sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
        }
        return sColorChange; // "rgba(" + sColorChange.join(",") + ")"
      } else {
        return sColor;
      }
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss"></style>
<style lang="scss" scoped>
#set {
  width: 520px;
  height: 400px;
  position: absolute;
  top: calc(50% - 260px);
  left: calc(50% - 260px);
  .contentCom {
    padding: 5px 15px;
    height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    .el-form{
      flex: 1;
      overflow-y: auto;
      padding-right: 5px;
    }
    /deep/.el-tabs__item {
      min-width: 100px;
      text-align: center;
    }
    .alignment {
      // /deep/.el-form-item__content {
      //   display: flex;
      //   flex-direction: row;
      //   align-items: center;
      // }
      /deep/.el-radio{
        margin-right: 15px;
      }
      /deep/.el-radio__input{
        display: none;
      }
    }
    /deep/.el-form-item {
      margin-bottom: 10px;
    }
    .choice {
      margin-left: 10px;
      font-size: 14px;
    }
  }
}
.skybox-list{
  margin-top: -15px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 5px 0;
  .skybox-image{
    width: 95px;
    height: 70px;
    background-color: rgb(170, 170, 170);
  }
  .name{
    line-height: 20px;
  }
}
.is-checked{
  /deep/.skybox-list{
    background-color: #4777e7;
    color: white;
  }
}
</style>
<style lang="scss">
.popperClass .el-color-dropdown__link-btn {
  display: none;
}
</style>
